import { type PngImageProps } from './pngImageTypes';
import { Image as RNImage } from 'react-native';

export default function PngImage({ source, style, resizeMode, ...props }: PngImageProps) {
  // Next.js’s Image will never work outside of Next.js’s infrastructure, so on our native builds, or web builds without Next.js (e.g. the pupil-app build we make) we can’t use Next.js’s Image

  return <RNImage source={source} style={style} resizeMode={resizeMode} {...props} />;
}
